export default __webpack_public_path__ + "static/media/twitter_logo.c4bdca1a.svg";